import Outline from './Outline.gql';

export default Outline;
